import {
	GetInboundEmailsRequest,
	PostInboundEmailsRequest,
	ToggleInboundEmailsRequest,
	PatchInboundEmailsRequest,
} from 'entities/inbound-emails/api/types';
import { axiosInstance } from 'shared/config/axios';

export const getInboundEmails: GetInboundEmailsRequest = () => {
	return axiosInstance.get('/inbound-emails');
};

export const postInboundEmails: PostInboundEmailsRequest = (data) => {
	return axiosInstance.post('/inbound-emails', data);
};

export const toggleInboundEmails: ToggleInboundEmailsRequest = ({ id }) => {
	return axiosInstance.patch(`/inbound-emails/${id}/toggle`);
};

export const patchInboundEmails: PatchInboundEmailsRequest = ({ id, data }) => {
	return axiosInstance.patch(`/inbound-emails/${id}`, data);
};
